import React from "react"
import { Dropdown, Input, TextArea, TagInput, Selector, Checkbox } from "frontend/components/forms"

const FIELD_COMPONENTS = {
  dropdown: Dropdown,
  input: Input,
  textarea: TextArea,
  taginput: TagInput,
  selector: Selector,
  checkbox: Checkbox,
}

const Field = (props) => {
  const { values, id, onChange, errors, fields, className } = props

  const fieldData = fields[id]

  if (!fieldData) {
    return null
  }

  const value = values.get(id)
  const error = errors.get(id)

  const { required, disabled, label, type, hidden } = fieldData
  const FieldComponent = FIELD_COMPONENTS[type]

  if (hidden) {
    return null
  }

  return (
    <FieldComponent
      {...fieldData}
      id={id}
      value={value}
      error={error}
      label={label}
      required={required}
      disabled={disabled}
      className={className}
      onChange={(newValue) => onChange(id, newValue)}
    />
  )
}

Field.defaultProps = {
  onChange: () => {},
}

export default Field
